import * as base from './base';
import * as types from 'constants/action-types';
import * as api from 'api';

export const fetchTips = (q, page = 1, perPage, sortOpts, extraFilters) =>
  base.fetchRecords(api.fetchTips, setTips, q, page, perPage, sortOpts, extraFilters);

export const setTips = (records, currentPage, pageCount, totalCount, itemsPerPage) => ({
  type: types.SET_TIPS,
  records,
  currentPage,
  pageCount,
  totalCount,
  itemsPerPage,
});

export const fetchTip = (recordId) => (dispatch) =>
  api.fetchTip(recordId).then((response) => {
    dispatch(setCurrentTip(recordId, response.record));
  });

export const setCurrentTipPage = (page) => ({
  type: types.SET_CURRENT_TIP_PAGE,
  page,
});

export const setCurrentTip = (recordId, recordData) => ({
  type: types.SET_CURRENT_TIP,
  recordId,
  recordData,
});

export const clearTipsAfterPage = (page) => ({
  type: types.CLEAR_TIPS_AFTER_PAGE,
  page,
});

export const fetchScrollableTips = (extraFilters) => (dispatch, getState) => {
  const {tips} = getState();
  const hasNext = tips.getIn(['scrollableTipPages', 'hasNext']);
  const currentPage = tips.getIn(['scrollableTipPages', 'currentPage']);
  if (!hasNext) {
    return Promise.resolve();
  }
  const nextPage = currentPage + 1;
  return api.fetchTips(undefined, nextPage, undefined, undefined, extraFilters).then((response) => {
    dispatch(setScrollableTips(response.records, nextPage, response.pageCount));
    return response;
  });
};

export const setScrollableTips = (records, nextPage, pageCount) => ({
  type: types.SET_SCROLLABLE_TIPS,
  records,
  nextPage,
  pageCount,
});

export const clearScrollableTips = (page) => ({
  type: types.CLEAR_SCROLLABLE_TIPS,
  page,
});
